import { FC, HTMLAttributes } from 'react';

import cn from 'classnames';

import styles from './Content.module.scss';

interface IContentProps extends HTMLAttributes<HTMLDivElement> {
	bordered?: boolean;
	filled?: boolean;
}

export const Content: FC<IContentProps> = ({ className, children, bordered = true, filled, ...props }) => {
	return (
		<div {...props} className={cn(className, styles.content, { [styles.bordered]: bordered, [styles.filled]: filled })}>
			{children}
		</div>
	);
};
